var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3998 5.8851L12.7924 4.2783L7.74667 9.30601L5.75984 7.31907L10.7867 2.27221L9.1809 0.666073H14.3998V5.8851ZM14.3998 7.86601V11.066C14.3998 13.3059 12.6397 15.066 10.3998 15.066H3.99976C1.75981 15.066 -0.000244141 13.3059 -0.000244141 11.066V4.66601C-0.000244141 2.42607 1.75981 0.666016 3.99976 0.666016H7.19976V2.74604H3.99976C2.87979 2.74604 2.07978 3.54604 2.07978 4.66601V11.066C2.07978 12.186 2.87979 12.986 3.99976 12.986H10.3998C11.5197 12.986 12.3197 12.186 12.3197 11.066V7.86601H14.3998Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/OpenIcon.facdf81eb181aa0baf6f3b82d6468190.svg";
export { ForwardRef as ReactComponent };